export enum Maps {
  Manufacturer = 'manufacturers',
  Category = 'categories',
  Regions = 'regions'
}
